import React from "react"


const PaymentSuccess = props => {

	return (
		<>
		  <main className="relative lg:min-h-full">
		    <div>
		      <div className="mx-auto max-w-2xl lg:max-w-7xl">
	          <h1 className="text-sm font-medium text-integria-green">Payment successful</h1>
	          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Thank you for your order</p>
	          <p className="mt-2 text-base text-gray-500">
	          	For any queries regarding your prescription, please contact your practitioner directly.
	          </p>
          </div>
		    </div>
		  </main>
		</>
	)
}

export default PaymentSuccess